import { PageHeader } from '@gs/ui';
import type { AppDefinition } from '../types';
import { useFavorites } from '../hooks/useFavorites';
import { getAppById } from '../data/apps';
import { EmptyFavorites } from '../components/EmptyFavorites';
import { AppGrid } from '../components/AppGrid';

export default function DashboardPage() {
  const { favs, toggle, isFav } = useFavorites();
  const apps: AppDefinition[] = favs.map(getAppById).filter((a): a is AppDefinition => a != null);

  return (
    <div className="space-y-6 pb-8">
      <PageHeader
        title="Mon tableau de bord"
        description="Vos applications favorites — cliquez l'étoile pour personnaliser."
      />

      {apps.length === 0 ? (
        <EmptyFavorites />
      ) : (
        <AppGrid apps={apps} showStar={false} isFav={isFav} onToggleFav={toggle} />
      )}
    </div>
  );
}
